import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SharedService } from './services/shared-service/shared.service';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  underMaintance: boolean = false;
  constructor(
    private router: Router,
    private titleService: Title,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private meta: Meta
  ) { }

  ngOnInit(): void {
    if (environment.noIndex) {
      this.meta.updateTag({
        name: 'robots',
        content: 'noindex, nofollow'
      });
    } else {
      this.meta.removeTag("name='robots'");
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      let rt = this.getChild(this.activatedRoute)
      rt.data.subscribe((data: { title: string; }) => {
        this.sharedService.getData().subscribe((data) => {
          this.titleService.setTitle(data)
        });
      });
    });
    this.underMaintance = environment.isUnderMaintance;
    if (this.underMaintance) {
      this.router.navigate(['under-maintenance']);
    }
  }

  getChild(activatedRoute: ActivatedRoute): any {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

}
